import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

import MySwiper from "../components/swiper/awards-swiper"
// import Nav from "react-bootstrap/Nav"
import {
  Container,
  Row,
  Col,
  DropdownButton,
  Dropdown,
  ButtonGroup,
  Tab,
} from "react-bootstrap"
import HeaderBg from "../images/services-bg.jpg"
import { StaticImage } from "gatsby-plugin-image"
import Swiper from "react-id-swiper"
import { Pagination, Navigation } from "swiper/dist/js/swiper.esm"
import "swiper/dist/css/swiper.css"
import "../sass/pages/services-new.scss"
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"

import FinancialPlanning from "../images/financial-planning.jpeg"
import InvestmentManagement from "../images/investment-management.jpg"
import WealthManagement from "../images/wealth-management.jpg"
import TaxPlanning from "../images/tax-planning.jpeg"
import Insurance from "../images/insurance.jpeg"
import Ekenna from "../images/services/quotes-img.jpg"

import logo1 from "../images/news-logos/investopedia-2.png"
import logo2 from "../images/news-logos/investopedia.png"
import logo3 from "../images/news-logos/wealth-management.png"
import logo4 from "../images/news-logos/expertise.png"
import logo5 from "../images/news-logos/expertise-2.png"
import logo6 from "../images/news-logos/channel-futures.png"
import logo7 from "../images/news-logos/marquis.png"

const investmentProcess = [
  {
    title: "BEST-IN-CLASS",
    shortdesc:
      "An approach where leading or best-performing investments within a universe, category, or class are selected or weighted based on ESG criteria.",
  },
  {
    title: "ENGAGEMENT & VOTING",
    shortdesc:
      "Engagement activities and active ownership through voting of shares and engagement with companies on ESG matters.",
  },
  {
    title: "ESG INTEGRATION",
    shortdesc:
      "The explicit inclusion by asset managers of ESG risks and opportunities into traditional financial analysis and investment decisions is based on a systematic process and appropriate research sources.",
  },
  {
    title: "EXCLUSIONS",
    shortdesc:
      "An approach that excludes specific investments or classes of investment from the investable universe such as companies, sectors, or countries.",
  },
  {
    title: "IMPACT INVESTING",
    shortdesc:
      "Impact Investments are investments made into companies, organizations and funds with the intention to generate social and environmental impact alongside a financial return.",
  },
  {
    title: "NORMS-BASED SCREENING",
    shortdesc:
      "Screening of investments according to their compliance with international standards and norms.",
  },
  {
    title: "SUSTAINABILITY THEMED",
    shortdesc:
      "Investment in themes or assets linked to the development of sustainability.",
  },
]

const params = {
  modules: Navigation,
  observer: true,
  observeParents: true,
  spaceBetween: 30,
  containerClass: "swiper-container",
  loop: true,
  speed: 8000,
  autoplay: {
    delay: 1,
  },
  breakpoints: {
    1000: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  },
  allowTouchMove: false,
  disableOnInteraction: true,
}

export default function Services(items) {
  const testimonial = items.data.allSanityTestimonials.edges

  const [activeTab, setActiveTab] = useState("1")
  return (
    <Layout>
      <SEO title={"Services"} description={"Services"} />{" "}
      <div className="page-header">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-xl-10">
              <div className="header-text">
                <h1 className="text-black mb-4">
                  Because Everyone Should Have a Financial Plan
                </h1>
                <p className="lead">
                  At Bay Street Capital Holdings, we are here to empower you on
                  your investment journey and explore the possibilities your
                  wealth can create. Your success is our success. Whether you’re
                  saving for retirement, a new car, the first purchase of your
                  home, or on the road to financial security, you can be
                  confident that we’re on your side.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="header-bg"
          style={{ backgroundImage: `url(${HeaderBg})` }}
        />
      </div>
      <div className="services-tabs" style={{ padding: "100px 0" }}>
        <Container>
          <h2 className="small-section-heading">A Comprehensive Approach</h2>
          <div>
            <Row className="align-items-center ">
              <Col lg="6" className="mb-5">
                {" "}
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      <Col lg="12" className="pe-lg-5 mb-5">
                        <h2 className="section-title">Financial Planning</h2>
                        <h4>
                          Navigating your financial goals is no easy feat but
                          with a plan in place, you can have the confidence to
                          achieve the purpose you envision for your life,
                          family, community, and beyond. Our comprehensive
                          approach to financial planning is built around
                          transparency and personalization.
                        </h4>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <Row>
                      <Col lg="12" className="pe-lg-5">
                        <h2 className="section-title">Investment Management</h2>
                        <h4>
                          At its core, investment management is about making the
                          most of your money. Your portfolio should reflect your
                          goals and the impact you want to create. We strive to
                          help clients realize their investment objects grounded
                          in strategic advice and planning.
                        </h4>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="3">
                    <Row>
                      <Col lg="12" className="pe-lg-5">
                        <h2 className="section-title">Wealth Management</h2>
                        <h4>
                          Your wealth isn’t just about money - it’s about the
                          growth, the preservation, and the protection of your
                          legacy and the impact you want to make for the future
                          of your needs, your family, or your business. Higher
                          wealth requires an extra level of support to address
                          the complexity and critical needs.
                        </h4>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="4">
                    <Row>
                      <Col lg="12" className="pe-lg-5">
                        <h2 className="section-title">Tax Planning</h2>
                        <h4>
                          Navigating taxes may be daunting but the right
                          guidance can make a world of difference to reach
                          better outcomes for your financial plan. We can guide
                          you through the options for structures, strategies,
                          and solutions that will help you on your journey to
                          transfer wealth efficiently.
                        </h4>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="5">
                    <Row>
                      <Col lg="12" className="pe-lg-5">
                        <h2 className="section-title">Life Insurance</h2>
                        <h4>
                          Ensuring financial security for your family is where
                          we can add value. Life insurance lets you take care of
                          the needs of your loved one in case of an unforeseen
                          event. We provide guidance for financial security that
                          makes sense for your family. All this, so you can
                          focus on what matters most.
                        </h4>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
              <Col lg="6">
                <Nav tabs>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="auto"
                    fill="none"
                    viewBox="0 0 1044 897"
                  >
                    <path
                      className={`${activeTab == "1" ? "active" : ""} main-svg`}
                      onMouseEnter={() => setActiveTab("1")}
                      fill="#051A36"
                      fillOpacity="0.1"
                      d="M522 0l452.065 224.25v448.5L522 897 69.935 672.75v-448.5L522 0z"
                    ></path>
                    <path
                      fill="#051A36"
                      d="M424.238 89.272v1.776h-7.272v5.64h5.904v1.776h-5.904V106h-2.184V89.272h9.456zm3.765 1.44c-.416 0-.768-.144-1.056-.432a1.436 1.436 0 01-.432-1.056c0-.416.144-.768.432-1.056.288-.288.64-.432 1.056-.432.4 0 .736.144 1.008.432.288.288.432.64.432 1.056 0 .416-.144.768-.432 1.056a1.331 1.331 0 01-1.008.432zm1.056 2.136V106h-2.184V92.848h2.184zm10.131-.24c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V106h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V106h-2.184V92.848h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm8.127 6.768c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V106h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm12.307-6.792c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V106h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V106h-2.184V92.848h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm8.127 6.792c0-1.36.272-2.544.816-3.552.544-1.024 1.296-1.816 2.256-2.376.976-.56 2.088-.84 3.336-.84 1.616 0 2.944.392 3.984 1.176 1.056.784 1.752 1.872 2.088 3.264h-2.352c-.224-.8-.664-1.432-1.32-1.896-.64-.464-1.44-.696-2.4-.696-1.248 0-2.256.432-3.024 1.296-.768.848-1.152 2.056-1.152 3.624 0 1.584.384 2.808 1.152 3.672.768.864 1.776 1.296 3.024 1.296.96 0 1.76-.224 2.4-.672.64-.448 1.08-1.088 1.32-1.92h2.352c-.352 1.344-1.056 2.424-2.112 3.24-1.056.8-2.376 1.2-3.96 1.2-1.248 0-2.36-.28-3.336-.84-.96-.56-1.712-1.352-2.256-2.376-.544-1.024-.816-2.224-.816-3.6zm16.523-8.688c-.416 0-.768-.144-1.056-.432a1.436 1.436 0 01-.432-1.056c0-.416.144-.768.432-1.056.288-.288.64-.432 1.056-.432.4 0 .736.144 1.008.432.288.288.432.64.432 1.056 0 .416-.144.768-.432 1.056a1.331 1.331 0 01-1.008.432zm1.056 2.136V106h-2.184V92.848h2.184zm2.906 6.528c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V106h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm8.083-11.16V106h-2.184V88.24h2.184zm21.304 5.928c0 1.392-.48 2.552-1.44 3.48-.944.912-2.392 1.368-4.344 1.368h-3.216V106h-2.184V89.272h5.4c1.888 0 3.32.456 4.296 1.368.992.912 1.488 2.088 1.488 3.528zm-5.784 3.048c1.216 0 2.112-.264 2.688-.792.576-.528.864-1.28.864-2.256 0-2.064-1.184-3.096-3.552-3.096h-3.216v6.144h3.216zm10.683-8.976V106h-2.184V88.24h2.184zm2.906 11.136c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V106h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm12.307-6.792c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V106h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V106h-2.184V92.848h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm15.351 0c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V106h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V106h-2.184V92.848h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm10.072-1.896c-.416 0-.768-.144-1.056-.432a1.436 1.436 0 01-.432-1.056c0-.416.144-.768.432-1.056.288-.288.64-.432 1.056-.432.4 0 .736.144 1.008.432.288.288.432.64.432 1.056 0 .416-.144.768-.432 1.056a1.331 1.331 0 01-1.008.432zm1.056 2.136V106h-2.184V92.848h2.184zm10.13-.24c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V106h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V106h-2.184V92.848h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm14.368.024c1.136 0 2.128.248 2.976.744.864.496 1.504 1.12 1.92 1.872v-2.4h2.208v13.44c0 1.2-.256 2.264-.768 3.192a5.434 5.434 0 01-2.208 2.208c-.944.528-2.048.792-3.312.792-1.728 0-3.168-.408-4.32-1.224-1.152-.816-1.832-1.928-2.04-3.336h2.16c.24.8.736 1.44 1.488 1.92.752.496 1.656.744 2.712.744 1.2 0 2.176-.376 2.928-1.128.768-.752 1.152-1.808 1.152-3.168v-2.76c-.432.768-1.072 1.408-1.92 1.92-.848.512-1.84.768-2.976.768-1.168 0-2.232-.288-3.192-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552 0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84zm4.896 6.768c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616z"
                    ></path>
                    <ellipse
                      className={activeTab == "3" ? "active" : ""}
                      onMouseEnter={() => setActiveTab("3")}
                      cx="522"
                      cy="303"
                      fill="#9d9ea1"
                      fillOpacity="0.5"
                      rx="181"
                      ry="171"
                    ></ellipse>
                    <path
                      fill="#fff"
                      d="M502.114 217.272L497.266 234h-2.448l-3.888-13.464L486.898 234l-2.424.024-4.68-16.752h2.328l3.648 14.184 4.032-14.184h2.448l3.84 14.136 3.672-14.136h2.352zm14.39 9.648c0 .416-.024.856-.072 1.32H505.92c.08 1.296.52 2.312 1.32 3.048.816.72 1.8 1.08 2.952 1.08.944 0 1.728-.216 2.352-.648a3.535 3.535 0 001.344-1.776h2.352a5.712 5.712 0 01-2.112 3.096c-1.056.784-2.368 1.176-3.936 1.176-1.248 0-2.368-.28-3.36-.84-.976-.56-1.744-1.352-2.304-2.376-.56-1.04-.84-2.24-.84-3.6 0-1.36.272-2.552.816-3.576.544-1.024 1.304-1.808 2.28-2.352.992-.56 2.128-.84 3.408-.84 1.248 0 2.352.272 3.312.816a5.55 5.55 0 012.208 2.256c.528.944.792 2.016.792 3.216zm-2.256-.456c0-.832-.184-1.544-.552-2.136a3.474 3.474 0 00-1.512-1.368c-.624-.32-1.32-.48-2.088-.48-1.104 0-2.048.352-2.832 1.056-.768.704-1.208 1.68-1.32 2.928h8.304zm4.323.912c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V234h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm8.083-11.16V234h-2.184v-17.76h2.184zm6.386 6.408v7.752c0 .64.136 1.096.408 1.368.272.256.744.384 1.416.384h1.608V234h-1.968c-1.216 0-2.128-.28-2.736-.84-.608-.56-.912-1.48-.912-2.76v-7.752h-1.704v-1.8h1.704v-3.312h2.184v3.312h3.432v1.8h-3.432zm12.606-2.04c.992 0 1.888.216 2.688.648.8.416 1.424 1.048 1.872 1.896.464.848.696 1.88.696 3.096V234h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V234h-2.184v-17.76h2.184v6.48a4.319 4.319 0 011.776-1.56c.768-.368 1.624-.552 2.568-.552zm-98.099 32.784V270h-2.184v-12.384L450.979 270h-1.536l-5.544-12.408V270h-2.184v-16.608h2.352l6.144 13.728 6.144-13.728h2.328zm2.888 9.984c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V270h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm12.307-6.792c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V270h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V270h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm8.127 6.768c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V270h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm11.323-6.768c1.136 0 2.128.248 2.976.744.864.496 1.504 1.12 1.92 1.872v-2.4h2.208v13.44c0 1.2-.256 2.264-.768 3.192a5.434 5.434 0 01-2.208 2.208c-.944.528-2.048.792-3.312.792-1.728 0-3.168-.408-4.32-1.224-1.152-.816-1.832-1.928-2.04-3.336h2.16c.24.8.736 1.44 1.488 1.92.752.496 1.656.744 2.712.744 1.2 0 2.176-.376 2.928-1.128.768-.752 1.152-1.808 1.152-3.168v-2.76c-.432.768-1.072 1.408-1.92 1.92-.848.512-1.84.768-2.976.768-1.168 0-2.232-.288-3.192-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552 0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84zm4.896 6.768c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm17.899-.48c0 .416-.024.856-.072 1.32h-10.512c.08 1.296.52 2.312 1.32 3.048.816.72 1.8 1.08 2.952 1.08.944 0 1.728-.216 2.352-.648a3.535 3.535 0 001.344-1.776h2.352a5.712 5.712 0 01-2.112 3.096c-1.056.784-2.368 1.176-3.936 1.176-1.248 0-2.368-.28-3.36-.84-.976-.56-1.744-1.352-2.304-2.376-.56-1.04-.84-2.24-.84-3.6 0-1.36.272-2.552.816-3.576.544-1.024 1.304-1.808 2.28-2.352.992-.56 2.128-.84 3.408-.84 1.248 0 2.352.272 3.312.816a5.55 5.55 0 012.208 2.256c.528.944.792 2.016.792 3.216zm-2.256-.456c0-.832-.184-1.544-.552-2.136a3.474 3.474 0 00-1.512-1.368c-.624-.32-1.32-.48-2.088-.48-1.104 0-2.048.352-2.832 1.056-.768.704-1.208 1.68-1.32 2.928h8.304zm20.955-5.856c1.024 0 1.936.216 2.736.648.8.416 1.432 1.048 1.896 1.896.464.848.696 1.88.696 3.096V270h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.64-.704-1.512-1.056-2.616-1.056-1.136 0-2.04.368-2.712 1.104-.672.72-1.008 1.768-1.008 3.144V270h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.64-.704-1.512-1.056-2.616-1.056-1.136 0-2.04.368-2.712 1.104-.672.72-1.008 1.768-1.008 3.144V270h-2.184v-13.152h2.184v1.896a4.336 4.336 0 011.728-1.584 5.343 5.343 0 012.424-.552c1.104 0 2.08.248 2.928.744.848.496 1.48 1.224 1.896 2.184a4.314 4.314 0 011.824-2.16c.848-.512 1.792-.768 2.832-.768zm20.91 6.312c0 .416-.024.856-.072 1.32H567.42c.08 1.296.52 2.312 1.32 3.048.816.72 1.8 1.08 2.952 1.08.944 0 1.728-.216 2.352-.648a3.535 3.535 0 001.344-1.776h2.352a5.712 5.712 0 01-2.112 3.096c-1.056.784-2.368 1.176-3.936 1.176-1.248 0-2.368-.28-3.36-.84-.976-.56-1.744-1.352-2.304-2.376-.56-1.04-.84-2.24-.84-3.6 0-1.36.272-2.552.816-3.576.544-1.024 1.304-1.808 2.28-2.352.992-.56 2.128-.84 3.408-.84 1.248 0 2.352.272 3.312.816a5.55 5.55 0 012.208 2.256c.528.944.792 2.016.792 3.216zm-2.256-.456c0-.832-.184-1.544-.552-2.136a3.474 3.474 0 00-1.512-1.368c-.624-.32-1.32-.48-2.088-.48-1.104 0-2.048.352-2.832 1.056-.768.704-1.208 1.68-1.32 2.928h8.304zm11.547-5.856c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V270h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V270h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm11.608 2.04v7.752c0 .64.136 1.096.408 1.368.272.256.744.384 1.416.384h1.608V270h-1.968c-1.216 0-2.128-.28-2.736-.84-.608-.56-.912-1.48-.912-2.76v-7.752h-1.704v-1.8h1.704v-3.312h2.184v3.312h3.432v1.8h-3.432z"
                    ></path>
                    <ellipse
                      className={activeTab == "5" ? "active" : ""}
                      onMouseEnter={() => setActiveTab("5")}
                      cx="708"
                      cy="474"
                      fill="#7580b8"
                      fillOpacity="0.5"
                      rx="181"
                      ry="171"
                    ></ellipse>
                    <path
                      fill="#fff"
                      d="M629.743 480.224h5.856V482h-8.04v-16.728h2.184v14.952zm9.303-13.512c-.416 0-.768-.144-1.056-.432a1.436 1.436 0 01-.432-1.056c0-.416.144-.768.432-1.056.288-.288.64-.432 1.056-.432.4 0 .736.144 1.008.432.288.288.432.64.432 1.056 0 .416-.144.768-.432 1.056a1.331 1.331 0 01-1.008.432zm1.056 2.136V482h-2.184v-13.152h2.184zm9.075 1.8h-2.76V482h-2.184v-11.352h-1.704v-1.8h1.704v-.936c0-1.472.376-2.544 1.128-3.216.768-.688 1.992-1.032 3.672-1.032v1.824c-.96 0-1.64.192-2.04.576-.384.368-.576.984-.576 1.848v.936h2.76v1.8zm14.546 4.272c0 .416-.024.856-.072 1.32h-10.512c.08 1.296.52 2.312 1.32 3.048.816.72 1.8 1.08 2.952 1.08.944 0 1.728-.216 2.352-.648a3.535 3.535 0 001.344-1.776h2.352a5.712 5.712 0 01-2.112 3.096c-1.056.784-2.368 1.176-3.936 1.176-1.248 0-2.368-.28-3.36-.84-.976-.56-1.744-1.352-2.304-2.376-.56-1.04-.84-2.24-.84-3.6 0-1.36.272-2.552.816-3.576.544-1.024 1.304-1.808 2.28-2.352.992-.56 2.128-.84 3.408-.84 1.248 0 2.352.272 3.312.816a5.55 5.55 0 012.208 2.256c.528.944.792 2.016.792 3.216zm-2.256-.456c0-.832-.184-1.544-.552-2.136a3.474 3.474 0 00-1.512-1.368c-.624-.32-1.32-.48-2.088-.48-1.104 0-2.048.352-2.832 1.056-.768.704-1.208 1.68-1.32 2.928h8.304zm13.721-9.192V482h-2.184v-16.728h2.184zm10.131 3.336c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V482h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V482h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm13.599 13.608c-1.008 0-1.912-.168-2.712-.504-.8-.352-1.432-.832-1.896-1.44a3.892 3.892 0 01-.768-2.136h2.256c.064.656.368 1.192.912 1.608.56.416 1.288.624 2.184.624.832 0 1.488-.184 1.968-.552.48-.368.72-.832.72-1.392 0-.576-.256-1-.768-1.272-.512-.288-1.304-.568-2.376-.84-.976-.256-1.776-.512-2.4-.768a4.557 4.557 0 01-1.584-1.176c-.432-.528-.648-1.216-.648-2.064 0-.672.2-1.288.6-1.848.4-.56.968-1 1.704-1.32.736-.336 1.576-.504 2.52-.504 1.456 0 2.632.368 3.528 1.104.896.736 1.376 1.744 1.44 3.024h-2.184c-.048-.688-.328-1.24-.84-1.656-.496-.416-1.168-.624-2.016-.624-.784 0-1.408.168-1.872.504-.464.336-.696.776-.696 1.32 0 .432.136.792.408 1.08.288.272.64.496 1.056.672.432.16 1.024.344 1.776.552.944.256 1.712.512 2.304.768a3.82 3.82 0 011.512 1.104c.432.496.656 1.144.672 1.944 0 .72-.2 1.368-.6 1.944-.4.576-.968 1.032-1.704 1.368-.72.32-1.552.48-2.496.48zm19.547-13.368V482h-2.184v-1.944c-.416.672-1 1.2-1.752 1.584-.736.368-1.552.552-2.448.552-1.024 0-1.944-.208-2.76-.624-.816-.432-1.464-1.072-1.944-1.92-.464-.848-.696-1.88-.696-3.096v-7.704h2.16v7.416c0 1.296.328 2.296.984 3 .656.688 1.552 1.032 2.688 1.032 1.168 0 2.088-.36 2.76-1.08.672-.72 1.008-1.768 1.008-3.144v-7.224h2.184zm5.872 2.136a4.212 4.212 0 011.632-1.752c.72-.416 1.592-.624 2.616-.624v2.256h-.576c-2.448 0-3.672 1.328-3.672 3.984V482h-2.184v-13.152h2.184v2.136zm5.953 4.392c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V482h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm12.307-6.792c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V482h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V482h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm8.127 6.792c0-1.36.272-2.544.816-3.552.544-1.024 1.296-1.816 2.256-2.376.976-.56 2.088-.84 3.336-.84 1.616 0 2.944.392 3.984 1.176 1.056.784 1.752 1.872 2.088 3.264h-2.352c-.224-.8-.664-1.432-1.32-1.896-.64-.464-1.44-.696-2.4-.696-1.248 0-2.256.432-3.024 1.296-.768.848-1.152 2.056-1.152 3.624 0 1.584.384 2.808 1.152 3.672.768.864 1.776 1.296 3.024 1.296.96 0 1.76-.224 2.4-.672.64-.448 1.08-1.088 1.32-1.92h2.352c-.352 1.344-1.056 2.424-2.112 3.24-1.056.8-2.376 1.2-3.96 1.2-1.248 0-2.36-.28-3.336-.84-.96-.56-1.712-1.352-2.256-2.376-.544-1.024-.816-2.224-.816-3.6zm27.394-.48c0 .416-.024.856-.072 1.32H778.67c.08 1.296.52 2.312 1.32 3.048.816.72 1.8 1.08 2.952 1.08.944 0 1.728-.216 2.352-.648a3.535 3.535 0 001.344-1.776h2.352a5.712 5.712 0 01-2.112 3.096c-1.056.784-2.368 1.176-3.936 1.176-1.248 0-2.368-.28-3.36-.84-.976-.56-1.744-1.352-2.304-2.376-.56-1.04-.84-2.24-.84-3.6 0-1.36.272-2.552.816-3.576.544-1.024 1.304-1.808 2.28-2.352.992-.56 2.128-.84 3.408-.84 1.248 0 2.352.272 3.312.816a5.55 5.55 0 012.208 2.256c.528.944.792 2.016.792 3.216zm-2.256-.456c0-.832-.184-1.544-.552-2.136a3.474 3.474 0 00-1.512-1.368c-.624-.32-1.32-.48-2.088-.48-1.104 0-2.048.352-2.832 1.056-.768.704-1.208 1.68-1.32 2.928h8.304z"
                    ></path>
                    <ellipse
                      className={activeTab == "2" ? "active" : ""}
                      onMouseEnter={() => setActiveTab("2")}
                      cx="522"
                      cy="645"
                      fill="#7580b8"
                      fillOpacity="0.2"
                      rx="181"
                      ry="171"
                    ></ellipse>
                    <path
                      fill="#fff"
                      d="M458.743 644.272V661h-2.184v-16.728h2.184zm10.13 3.336c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V661h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V661h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm13.84 11.376l4.08-11.136h2.328L483.961 661h-2.544l-5.16-13.152h2.352l4.104 11.136zm20.557-5.064c0 .416-.024.856-.072 1.32h-10.512c.08 1.296.52 2.312 1.32 3.048.816.72 1.8 1.08 2.952 1.08.944 0 1.728-.216 2.352-.648a3.535 3.535 0 001.344-1.776h2.352a5.712 5.712 0 01-2.112 3.096c-1.056.784-2.368 1.176-3.936 1.176-1.248 0-2.368-.28-3.36-.84-.976-.56-1.744-1.352-2.304-2.376-.56-1.04-.84-2.24-.84-3.6 0-1.36.272-2.552.816-3.576.544-1.024 1.304-1.808 2.28-2.352.992-.56 2.128-.84 3.408-.84 1.248 0 2.352.272 3.312.816a5.55 5.55 0 012.208 2.256c.528.944.792 2.016.792 3.216zm-2.256-.456c0-.832-.184-1.544-.552-2.136a3.474 3.474 0 00-1.512-1.368c-.624-.32-1.32-.48-2.088-.48-1.104 0-2.048.352-2.832 1.056-.768.704-1.208 1.68-1.32 2.928h8.304zm9.795 7.752c-1.008 0-1.912-.168-2.712-.504-.8-.352-1.432-.832-1.896-1.44a3.892 3.892 0 01-.768-2.136h2.256c.064.656.368 1.192.912 1.608.56.416 1.288.624 2.184.624.832 0 1.488-.184 1.968-.552.48-.368.72-.832.72-1.392 0-.576-.256-1-.768-1.272-.512-.288-1.304-.568-2.376-.84-.976-.256-1.776-.512-2.4-.768a4.557 4.557 0 01-1.584-1.176c-.432-.528-.648-1.216-.648-2.064 0-.672.2-1.288.6-1.848.4-.56.968-1 1.704-1.32.736-.336 1.576-.504 2.52-.504 1.456 0 2.632.368 3.528 1.104.896.736 1.376 1.744 1.44 3.024h-2.184c-.048-.688-.328-1.24-.84-1.656-.496-.416-1.168-.624-2.016-.624-.784 0-1.408.168-1.872.504-.464.336-.696.776-.696 1.32 0 .432.136.792.408 1.08.288.272.64.496 1.056.672.432.16 1.024.344 1.776.552.944.256 1.712.512 2.304.768a3.82 3.82 0 011.512 1.104c.432.496.656 1.144.672 1.944 0 .72-.2 1.368-.6 1.944-.4.576-.968 1.032-1.704 1.368-.72.32-1.552.48-2.496.48zm10.547-11.568v7.752c0 .64.136 1.096.408 1.368.272.256.744.384 1.416.384h1.608V661h-1.968c-1.216 0-2.128-.28-2.736-.84-.608-.56-.912-1.48-.912-2.76v-7.752h-1.704v-1.8h1.704v-3.312h2.184v3.312h3.432v1.8h-3.432zm21.894-2.04c1.024 0 1.936.216 2.736.648.8.416 1.432 1.048 1.896 1.896.464.848.696 1.88.696 3.096V661h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.64-.704-1.512-1.056-2.616-1.056-1.136 0-2.04.368-2.712 1.104-.672.72-1.008 1.768-1.008 3.144V661h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.64-.704-1.512-1.056-2.616-1.056-1.136 0-2.04.368-2.712 1.104-.672.72-1.008 1.768-1.008 3.144V661h-2.184v-13.152h2.184v1.896a4.336 4.336 0 011.728-1.584 5.343 5.343 0 012.424-.552c1.104 0 2.08.248 2.928.744.848.496 1.48 1.224 1.896 2.184a4.314 4.314 0 011.824-2.16c.848-.512 1.792-.768 2.832-.768zm20.911 6.312c0 .416-.024.856-.072 1.32h-10.512c.08 1.296.52 2.312 1.32 3.048.816.72 1.8 1.08 2.952 1.08.944 0 1.728-.216 2.352-.648a3.535 3.535 0 001.344-1.776h2.352a5.712 5.712 0 01-2.112 3.096c-1.056.784-2.368 1.176-3.936 1.176-1.248 0-2.368-.28-3.36-.84-.976-.56-1.744-1.352-2.304-2.376-.56-1.04-.84-2.24-.84-3.6 0-1.36.272-2.552.816-3.576.544-1.024 1.304-1.808 2.28-2.352.992-.56 2.128-.84 3.408-.84 1.248 0 2.352.272 3.312.816a5.55 5.55 0 012.208 2.256c.528.944.792 2.016.792 3.216zm-2.256-.456c0-.832-.184-1.544-.552-2.136a3.474 3.474 0 00-1.512-1.368c-.624-.32-1.32-.48-2.088-.48-1.104 0-2.048.352-2.832 1.056-.768.704-1.208 1.68-1.32 2.928h8.304zm11.546-5.856c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V661h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V661h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm11.608 2.04v7.752c0 .64.136 1.096.408 1.368.272.256.744.384 1.416.384h1.608V661h-1.968c-1.216 0-2.128-.28-2.736-.84-.608-.56-.912-1.48-.912-2.76v-7.752h-1.704v-1.8h1.704v-3.312h2.184v3.312h3.432v1.8h-3.432zm-125.876 30.744V697h-2.184v-12.384L451.479 697h-1.536l-5.544-12.408V697h-2.184v-16.608h2.352l6.144 13.728 6.144-13.728h2.328zm2.888 9.984c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V697h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm12.307-6.792c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V697h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V697h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm8.127 6.768c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V697h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm11.323-6.768c1.136 0 2.128.248 2.976.744.864.496 1.504 1.12 1.92 1.872v-2.4h2.208v13.44c0 1.2-.256 2.264-.768 3.192a5.434 5.434 0 01-2.208 2.208c-.944.528-2.048.792-3.312.792-1.728 0-3.168-.408-4.32-1.224-1.152-.816-1.832-1.928-2.04-3.336h2.16c.24.8.736 1.44 1.488 1.92.752.496 1.656.744 2.712.744 1.2 0 2.176-.376 2.928-1.128.768-.752 1.152-1.808 1.152-3.168v-2.76c-.432.768-1.072 1.408-1.92 1.92-.848.512-1.84.768-2.976.768-1.168 0-2.232-.288-3.192-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552 0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84zm4.896 6.768c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm17.899-.48c0 .416-.024.856-.072 1.32h-10.512c.08 1.296.52 2.312 1.32 3.048.816.72 1.8 1.08 2.952 1.08.944 0 1.728-.216 2.352-.648a3.535 3.535 0 001.344-1.776h2.352a5.712 5.712 0 01-2.112 3.096c-1.056.784-2.368 1.176-3.936 1.176-1.248 0-2.368-.28-3.36-.84-.976-.56-1.744-1.352-2.304-2.376-.56-1.04-.84-2.24-.84-3.6 0-1.36.272-2.552.816-3.576.544-1.024 1.304-1.808 2.28-2.352.992-.56 2.128-.84 3.408-.84 1.248 0 2.352.272 3.312.816a5.55 5.55 0 012.208 2.256c.528.944.792 2.016.792 3.216zm-2.256-.456c0-.832-.184-1.544-.552-2.136a3.474 3.474 0 00-1.512-1.368c-.624-.32-1.32-.48-2.088-.48-1.104 0-2.048.352-2.832 1.056-.768.704-1.208 1.68-1.32 2.928h8.304zm20.955-5.856c1.024 0 1.936.216 2.736.648.8.416 1.432 1.048 1.896 1.896.464.848.696 1.88.696 3.096V697h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.64-.704-1.512-1.056-2.616-1.056-1.136 0-2.04.368-2.712 1.104-.672.72-1.008 1.768-1.008 3.144V697h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.64-.704-1.512-1.056-2.616-1.056-1.136 0-2.04.368-2.712 1.104-.672.72-1.008 1.768-1.008 3.144V697h-2.184v-13.152h2.184v1.896a4.336 4.336 0 011.728-1.584 5.343 5.343 0 012.424-.552c1.104 0 2.08.248 2.928.744.848.496 1.48 1.224 1.896 2.184a4.314 4.314 0 011.824-2.16c.848-.512 1.792-.768 2.832-.768zm20.91 6.312c0 .416-.024.856-.072 1.32H567.92c.08 1.296.52 2.312 1.32 3.048.816.72 1.8 1.08 2.952 1.08.944 0 1.728-.216 2.352-.648a3.535 3.535 0 001.344-1.776h2.352a5.712 5.712 0 01-2.112 3.096c-1.056.784-2.368 1.176-3.936 1.176-1.248 0-2.368-.28-3.36-.84-.976-.56-1.744-1.352-2.304-2.376-.56-1.04-.84-2.24-.84-3.6 0-1.36.272-2.552.816-3.576.544-1.024 1.304-1.808 2.28-2.352.992-.56 2.128-.84 3.408-.84 1.248 0 2.352.272 3.312.816a5.55 5.55 0 012.208 2.256c.528.944.792 2.016.792 3.216zm-2.256-.456c0-.832-.184-1.544-.552-2.136a3.474 3.474 0 00-1.512-1.368c-.624-.32-1.32-.48-2.088-.48-1.104 0-2.048.352-2.832 1.056-.768.704-1.208 1.68-1.32 2.928h8.304zm11.547-5.856c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V697h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V697h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm11.608 2.04v7.752c0 .64.136 1.096.408 1.368.272.256.744.384 1.416.384h1.608V697h-1.968c-1.216 0-2.128-.28-2.736-.84-.608-.56-.912-1.48-.912-2.76v-7.752h-1.704v-1.8h1.704v-3.312h2.184v3.312h3.432v1.8h-3.432z"
                    ></path>
                    <ellipse
                      className={activeTab == "4" ? "active" : ""}
                      onMouseEnter={() => setActiveTab("4")}
                      cx="346"
                      cy="474"
                      fill="#7580b8"
                      fillOpacity="0.7"
                      rx="181"
                      ry="171"
                    ></ellipse>
                    <path
                      fill="#fff"
                      d="M277.499 465.272v1.776h-4.56V482h-2.184v-14.952h-4.584v-1.776h11.328zm1.873 10.104c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V482h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm12.763 6.6l-3.12-4.896-3 4.896h-2.28l4.248-6.528-4.248-6.624h2.472l3.12 4.872 2.976-4.872h2.28l-4.224 6.504 4.248 6.648h-2.472zm22.202-11.832c0 1.392-.48 2.552-1.44 3.48-.944.912-2.392 1.368-4.344 1.368h-3.216V482h-2.184v-16.728h5.4c1.888 0 3.32.456 4.296 1.368.992.912 1.488 2.088 1.488 3.528zm-5.784 3.048c1.216 0 2.112-.264 2.688-.792.576-.528.864-1.28.864-2.256 0-2.064-1.184-3.096-3.552-3.096h-3.216v6.144h3.216zm10.683-8.976V482h-2.184v-17.76h2.184zm2.906 11.136c0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84 1.152 0 2.152.248 3 .744.848.496 1.48 1.12 1.896 1.872v-2.4h2.208V482h-2.208v-2.448c-.432.768-1.08 1.408-1.944 1.92-.848.496-1.84.744-2.976.744-1.168 0-2.224-.288-3.168-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552zm11.136.024c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616zm12.307-6.792c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V482h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V482h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm15.351 0c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V482h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V482h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm10.072-1.896c-.416 0-.768-.144-1.056-.432a1.436 1.436 0 01-.432-1.056c0-.416.144-.768.432-1.056.288-.288.64-.432 1.056-.432.4 0 .736.144 1.008.432.288.288.432.64.432 1.056 0 .416-.144.768-.432 1.056a1.331 1.331 0 01-1.008.432zm1.056 2.136V482h-2.184v-13.152h2.184zm10.13-.24c1.6 0 2.896.488 3.888 1.464.992.96 1.488 2.352 1.488 4.176V482h-2.16v-7.44c0-1.312-.328-2.312-.984-3-.656-.704-1.552-1.056-2.688-1.056-1.152 0-2.072.36-2.76 1.08-.672.72-1.008 1.768-1.008 3.144V482h-2.184v-13.152h2.184v1.872a4.354 4.354 0 011.752-1.56 5.547 5.547 0 012.472-.552zm14.368.024c1.136 0 2.128.248 2.976.744.864.496 1.504 1.12 1.92 1.872v-2.4h2.208v13.44c0 1.2-.256 2.264-.768 3.192a5.434 5.434 0 01-2.208 2.208c-.944.528-2.048.792-3.312.792-1.728 0-3.168-.408-4.32-1.224-1.152-.816-1.832-1.928-2.04-3.336h2.16c.24.8.736 1.44 1.488 1.92.752.496 1.656.744 2.712.744 1.2 0 2.176-.376 2.928-1.128.768-.752 1.152-1.808 1.152-3.168v-2.76c-.432.768-1.072 1.408-1.92 1.92-.848.512-1.84.768-2.976.768-1.168 0-2.232-.288-3.192-.864-.944-.576-1.688-1.384-2.232-2.424-.544-1.04-.816-2.224-.816-3.552 0-1.344.272-2.52.816-3.528.544-1.024 1.288-1.816 2.232-2.376.96-.56 2.024-.84 3.192-.84zm4.896 6.768c0-.992-.2-1.856-.6-2.592-.4-.736-.944-1.296-1.632-1.68-.672-.4-1.416-.6-2.232-.6-.816 0-1.56.192-2.232.576-.672.384-1.208.944-1.608 1.68-.4.736-.6 1.6-.6 2.592 0 1.008.2 1.888.6 2.64.4.736.936 1.304 1.608 1.704a4.419 4.419 0 002.232.576c.816 0 1.56-.192 2.232-.576a4.295 4.295 0 001.632-1.704c.4-.752.6-1.624.6-2.616z"
                    ></path>
                    <g filter="url(#filter0_d_2_24)">
                      <path
                        fill="#D9D9D9"
                        d="M522 396l77.942 39.25v78.5L522 553l-77.942-39.25v-78.5L522 396z"
                      ></path>
                    </g>
                    <path
                      fill="#051A36"
                      d="M513.201 463.272l-5.448 10.416V480h-2.184v-6.312l-5.472-10.416h2.424l4.128 8.472 4.128-8.472h2.424zm8.039 16.944c-1.232 0-2.352-.28-3.36-.84a6.105 6.105 0 01-2.352-2.376c-.56-1.04-.84-2.24-.84-3.6 0-1.344.288-2.528.864-3.552.592-1.04 1.392-1.832 2.4-2.376 1.008-.56 2.136-.84 3.384-.84 1.248 0 2.376.28 3.384.84a5.897 5.897 0 012.376 2.352c.592 1.024.888 2.216.888 3.576 0 1.36-.304 2.56-.912 3.6a6.178 6.178 0 01-2.424 2.376c-1.024.56-2.16.84-3.408.84zm0-1.92c.784 0 1.52-.184 2.208-.552.688-.368 1.24-.92 1.656-1.656.432-.736.648-1.632.648-2.688 0-1.056-.208-1.952-.624-2.688-.416-.736-.96-1.28-1.632-1.632a4.474 4.474 0 00-2.184-.552c-.8 0-1.536.184-2.208.552-.656.352-1.184.896-1.584 1.632-.4.736-.6 1.632-.6 2.688 0 1.072.192 1.976.576 2.712.4.736.928 1.288 1.584 1.656a4.496 4.496 0 002.16.528zm21.28-11.448V480h-2.184v-1.944c-.416.672-1 1.2-1.752 1.584-.736.368-1.552.552-2.448.552-1.024 0-1.944-.208-2.76-.624-.816-.432-1.464-1.072-1.944-1.92-.464-.848-.696-1.88-.696-3.096v-7.704h2.16v7.416c0 1.296.328 2.296.984 3 .656.688 1.552 1.032 2.688 1.032 1.168 0 2.088-.36 2.76-1.08.672-.72 1.008-1.768 1.008-3.144v-7.224h2.184z"
                    ></path>
                    <defs>
                      <filter
                        id="filter0_d_2_24"
                        width="163.885"
                        height="165"
                        x="440.058"
                        y="396"
                        colorInterpolationFilters="sRGB"
                        filterUnits="userSpaceOnUse"
                      >
                        <feFlood
                          floodOpacity="0"
                          result="BackgroundImageFix"
                        ></feFlood>
                        <feColorMatrix
                          in="SourceAlpha"
                          result="hardAlpha"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        ></feColorMatrix>
                        <feOffset dy="4"></feOffset>
                        <feGaussianBlur stdDeviation="2"></feGaussianBlur>
                        <feComposite
                          in2="hardAlpha"
                          operator="out"
                        ></feComposite>
                        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
                        <feBlend
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_2_24"
                        ></feBlend>
                        <feBlend
                          in="SourceGraphic"
                          in2="effect1_dropShadow_2_24"
                          result="shape"
                        ></feBlend>
                      </filter>
                    </defs>
                  </svg>
                </Nav>
              </Col>
            </Row>
          </div>

          <Nav
            tabs
            className="services-tab-shadow"
            style={{ margin: "100px 0" }}
          >
            <NavItem>
              <NavLink
                className={activeTab == "1" ? "active py-4 px-1" : "py-4 px-1"}
                onClick={() => setActiveTab("1")}
              >
                Financial Planning
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab == "2" ? "active py-4 px-1" : "py-4 px-1"}
                onClick={() => setActiveTab("2")}
              >
                Investment Management
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab == "3" ? "active py-4 px-1" : "py-4 px-1"}
                onClick={() => setActiveTab("3")}
              >
                Wealth Management
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab == "4" ? "active py-4 px-1" : "py-4 px-1"}
                onClick={() => setActiveTab("4")}
              >
                Tax Planning
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab == "5" ? "active py-4 px-1" : "py-4 px-1"}
                onClick={() => setActiveTab("5")}
              >
                Life Insurance{" "}
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Row className="g-5">
                <Col lg="6">
                  <h2 className="section-title">Financial Planning</h2>
                  <h4>
                    Prepare for your future and find peace of mind with Bay
                    Street's comprehensive, personalized approach to financial
                    planning. Our accredited fiduciary financial advisors work
                    closely with you to assess your current financial assets,
                    identify any potential roadblocks and build a financial plan
                    tailored specifically to your long-term goals.
                  </h4>
                  <h4 className="mt-4">
                    The best part? We handle it all, so you don’t have to. Once
                    a plan is in place, we keep things in sync so that you can
                    relax and fulfill the purpose you envision for your life.
                  </h4>
                </Col>
                <Col lg="6">
                  <img src={FinancialPlanning} className="img-fluid" />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              {" "}
              <Row className="g-5">
                <Col lg="6">
                  <h2 className="section-title">Investment Management</h2>
                  <h4>
                    Investment opportunities can change by the day. Here at Bay
                    Street, we are proactive and focused on optimizing your
                    portfolios based on market conditions. Our team of
                    accredited, fiduciary-certified financial planners are fully
                    equipped to monitor, reallocate, and sell — as necessary —
                    every position within your portfolio regularly and
                    meticulously. When you work with Bay Street, you can have
                    peace of mind that our team of experts are working daily to
                    maximize gains, reduce risks, and protect your investments.
                  </h4>
                </Col>
                <Col lg="6">
                  <img src={InvestmentManagement} className="img-fluid" />
                </Col>
              </Row>
              <div className="mt-5">
                <h3 className="section-title text-center">
                  Our Investment Process
                </h3>

                <Row className="justify-content-center g-4">
                  {investmentProcess.map((item, i) => (
                    <Col md={4} xl={3} key={i}>
                      <div className="box-with-shadow text-center h-100">
                        <h4
                          className="text-black font-medium mb-3"
                          style={{
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 400,
                            lineHeight: 1.25,
                          }}
                        >
                          {item.title}
                        </h4>
                        <p>{item.shortdesc}</p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </TabPane>
            <TabPane tabId="3">
              {" "}
              <Row className="g-5">
                <Col lg="6">
                  <h2 className="section-title">Wealth Management</h2>
                  <h4>
                    We take a comprehensive tailored approach to help preserve
                    your legacy. We can be the guide to your wealth management
                    needs and the protection of your assets. As a Bay Street
                    client, you can be confident that we take the time to
                    understand your unique values and aspirations and take a
                    valued-based approach to your wealth. We work with you to
                    provide strategies that focus on what’s important to you,
                    your needs, and the plan you envision for your personal
                    needs, family, or business.
                  </h4>
                </Col>
                <Col lg="6">
                  <img src={WealthManagement} className="img-fluid" />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="4">
              <Row className="g-5">
                <Col lg="6">
                  <h2 className="section-title">Tax Planning </h2>
                  <h4>
                    Taxes are an inevitable part of money management, but with
                    Bay Street, you can be confident that our team of accredited
                    financial advisors will aim to reduce the impact of taxes
                    across multiple areas of your comprehensive financial plan.
                    We implement prudent tax to lessen or shift current and
                    future tax liabilities to meet your financial objectives.
                  </h4>
                </Col>
                <Col lg="6">
                  <img src={TaxPlanning} className="img-fluid" />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="5">
              <Row className="g-5">
                <Col lg="6">
                  <h2 className="section-title">Life Insurance </h2>
                  <h4>
                    Unforeseen difficulties may arise if a main source of income
                    is lost. Help ease your mind with coverage that you and your
                    family can rely on. Life insurance is an important aspect of
                    a strong financial plan and your peace of mind doesn’t have
                    to break the bank. Let us take the guesswork out of life
                    insurance to whatever fits your individual life stage and
                    needs.
                  </h4>
                </Col>
                <Col lg="6">
                  <img src={Insurance} className="img-fluid" />
                </Col>
              </Row>
              <div
                className="available-services"
                style={{ paddingTop: "7rem", paddingBottom: "7rem" }}
              >
                <Row>
                  <Tab.Container defaultActiveKey="1">
                    <Col
                      lg={12}
                      className="available-services-list services-tabs"
                    >
                      <div className="section-title">
                        <DropdownButton
                          id="dropdown-item-button"
                          title="Available Services"
                          className="hmenu-button"
                        >
                          <div
                            className="d-flex flex-column"
                            style={{ width: "max-content" }}
                          >
                            <NavItem>
                              <NavLink
                                className={activeTab == "5" ? "active" : ""}
                                onClick={() => setActiveTab("5")}
                              >
                                Insurance{" "}
                              </NavLink>
                            </NavItem>
                          </div>
                        </DropdownButton>
                      </div>
                    </Col>
                    <Col sm={12} style={{ paddingTop: "20px" }}>
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="5">
                          <Row>
                            <Col lg="12">
                              <Row className="d-flex align-items-center">
                                <Col md="3" lg="2">
                                  <div className="services-image">
                                    <StaticImage
                                      className="my-3"
                                      src="../images/life-insurance.jpeg"
                                    />
                                  </div>
                                </Col>
                                <Col md="9" lg="10">
                                  <div className="services-info">
                                    <h4 className="services-category">
                                      Insurance
                                    </h4>
                                    <h3 className="services-title">
                                      <Link to="/life-insurance">
                                        Life Insurance
                                      </Link>
                                    </h3>
                                    <p className="services-shortdesc">
                                      Confidence creates peace of mind, allowing
                                      you to live your life to the fullest. No
                                      one is immune to accidents no matter how
                                      young or healthy. Bring peace of mind to
                                      you and your family.
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                    </Col>
                  </Tab.Container>
                </Row>
              </div>
            </TabPane>
          </TabContent>

          {/* <Tab.Container id="left-tabs-example" defaultActiveKey="1">
            
            <Row className="align-items-center">
              
              <Col sm={12} style={{ paddingTop: "100px" }}>
                <Tab.Content>
                 
                 
        
                  <Tab.Pane eventKey="5">
                    <Row>
                      <Col lg="7">
                        <h2 className="section-title">Insurance </h2>
                        <h4>
                          Whether it's auto, business, home, health, or life
                          insurance, we’ve brought together everything you need
                          to protect your assets. You deserve protection and
                          peace of mind from potential financial consequences
                          and that’s where we can add value. All this, so you
                          can focus on what matters most.
                        </h4>
                      </Col>
                      <Col lg="6"></Col>
                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container> */}
        </Container>
      </div>
      <div style={{ paddingTop: "7rem", paddingBottom: "7rem" }}>
        <div className="container">
          <div className="row text-center mb-5">
            <div className="col-lg-9 mx-auto">
              <h2 className="section-title text-center mb-4">
                How We Work With You
              </h2>
              <p className="h4" style={{ lineHeight: 1.7 }}>
                At Bay Street, we are confident in our ability to craft a
                comprehensive strategy tailored to your goals and deliver action
                and results. We ensure our recommendations are prudent and align
                with your interests and goals.
              </p>
            </div>
          </div>
          <div className="row text-center mt-5 g-5">
            <div className="col-md-4 mb-3">
              <div className="mission-list-item">
                <StaticImage
                  className="my-3"
                  src="../images/accountability.png"
                />
                <div className="my-3 my_card_title">Meet With Our Team</div>
                <div className="color_dark my-3 my_card_desc">
                  You’ll meet one-on-one with our team for an introduction so we
                  can get an insight into your story and see how we can help you
                  achieve your goals.
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <div className="mission-list-item">
                <StaticImage className="my-3" src="../images/strategy.png" />
                <div className="my-3 my_card_title">
                  Comprehensive Deep-Dive
                </div>
                <div className="color_dark my-3 my_card_desc">
                  We’ll take a complete picture of your financial life, discuss
                  your goals, and develop a comprehensive, personalized strategy
                  tailored to you.
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <div className="mission-list-item">
                <StaticImage className="my-3" src="../images/performance.png" />
                <div className="my-3 my_card_title"> Plan Execution</div>
                <div className="color_dark my-3 my_card_desc">
                  We present our personalized financial plan that factors in
                  multiple market scenarios and our strategies that best align
                  with your resources to reach your goals, regardless of market
                  conditions. You decide the course of action.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="quote-section">
        <Row>
          <Col lg="5">
            <div className="quote-text">
              {" "}
              <h3 className="section-title font-italic text-left mb-4">
                Because everyone should have a financial plan
              </h3>
              <p className="font-italic font-weight-bold mb-0">
                -Ekenna Anya Gafu, CFP®, AAMS® CFO & Director of Planning
              </p>
              <p className=""></p>
            </div>
          </Col>{" "}
          <Col lg="7" className="quote-img" />
        </Row>
      </div> */}
      <div className="section_padding services-quote">
        <div className="container">
          <div className="row">
            <div className="qoute-body">
              <div className="col-lg-6">
                <div className="text-left section-info">
                  <h4 className="mb-3">
                    “Because everyone should have a financial plan”
                  </h4>
                  <h6 className="text-dark">
                    -Ekenna Anya Gafu, CFP®, AAMS® CFO & Director of Planning
                  </h6>
                </div>
              </div>
              <div className="col-md-12 d-lg-none mt-4">
                <StaticImage
                  placeholder="blurred"
                  layout="constrained"
                  fit="cover"
                  src="../images/services/quotes-img.jpg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div
        id="quotes"
        style={{
          paddingBottom: "7rem",
          paddingTop: "17rem",
          marginTop: "-17rem",
        }}
      >
        <div className="container">
  
          <Row className="align-items-center">
            <Col lg="8">
              <div className="px-md-5">
                <div className="quotes-swiper-wrapper">
                  <div className="row justify-content-center">
                    <div className="col-9 col-md-10">
                      <div className="py-5 d-flex align-items-center">
                        <div>
                          <p className="mb-4" style={{ color: "#6a7885" }}>
                            Because everyone should have a financial plan
                          </p>
                          <p className="font-italic font-weight-bold">
                            -Ekenna Anya Gafu, CFP®, AAMS® CFO & Director of
                            Planning
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="4">
              <div className="team-member-item position-relative">
                <div
                  className="team-member-item-img"
                  style={{
                    backgroundImage: `url(https://cdn.sanity.io/images/eydex0le/production/eec6c7d04b347e72c308ad0f7c085130478b00fc-1600x752.jpg?w=1600&h=752&auto=format)`,
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div> */}
      <div className="section_padding awards">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="text-left section-heading">
                <h2 className="section-title text-gold text-left mb-3 text-white">
                  Awards and Recognitions
                </h2>
                <h5 className="text-white">
                  We are honored to be recognized for our accomplishments and
                  our financial performance
                </h5>
              </div>
            </div>
            <div className="col-md-8">
              <MySwiper slidesperview="3">
                <div>
                  <img src={logo1} className="img-fluid"></img>
                </div>
                <div>
                  <img src={logo2} className="img-fluid"></img>
                </div>
                <div>
                  <img src={logo3} className="img-fluid"></img>
                </div>
                <div>
                  <img src={logo4} className="img-fluid"></img>
                </div>
                <div>
                  <img src={logo5} className="img-fluid"></img>
                </div>
                <div>
                  <img src={logo6} className="img-fluid"></img>
                </div>
                <div className="awards-item">
                  <img src={logo7} className="img-fluid"></img>
                </div>
              </MySwiper>
            </div>
          </div>
        </div>
        <div className="overlay"></div>
      </div>
      <div
        style={{ paddingTop: "7rem", paddingBottom: "7rem" }}
        className="bg_dark_parimary our_clients"
      >
        <div className="container">
          <h2 className="section-title text-white text-center">
            Trusted By Our Clients
          </h2>
          <div className="testimonials-swiper-wrapper">
            <Swiper
              modules={(Pagination, Navigation)}
              // navigation={{
              //   nextEl: ".swiper-button-next",
              //   prevEl: ".swiper-button-prev",
              // }}
              slidesPerView={1}
              spaceBetween={30}
              speed={700}
              // pagination={{
              //   el: ".swiper-pagination",
              //   type: "bullets",
              //   clickable: true,
              // }}
              autoHeight={true}
              {...params}
            >
              {testimonial.map((item, i) => (
                <div key={i}>
                  <div className="row justify-content-center">
                    <div className="col-12 col-md-10">
                      <span className="w-100 d-flex justify-content-center">
                        <StaticImage src="../images/rating.webp" />
                      </span>
                      <p className="lead font-italic text-white-50 text-center my-4">
                        {item.node.feedback}
                      </p>
                      <span className="h5 my-0 pb-0 text-uppercase font-weight-bold text-white d-block text-center">
                        {item.node.reviewer}
                      </span>
                      <small className="text-secondary text-center d-block">
                        on {item.node.date}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const ServicesQuery = graphql`
  query ServicesQuery {
    allSanityTestimonials(sort: { order: DESC, fields: date }, limit: 10) {
      edges {
        node {
          id
          reviewer
          rating
          feedback
          feedback_es
          date(formatString: "MMMM DD, YYYY")
        }
      }
    }
  }
`
